import React from 'react';

const Info = ( { styleText = '', children} ) => {
    return (
        <div className={`info ${styleText}`}>{children}</div>
    );
};
export default Info;
